import { useContainer } from "../../oneportal/hooks/useContainer"
import { SalesLinks } from "../links"

export const useSalesLinks = (): SalesLinks => useContainer().salesLinks
